import { render } from "./OfferTooltipInfo.vue?vue&type=template&id=ee38a8b2&scoped=true"
import script from "./OfferTooltipInfo.vue?vue&type=script&lang=js"
export * from "./OfferTooltipInfo.vue?vue&type=script&lang=js"

import "./OfferTooltipInfo.vue?vue&type=style&index=0&id=ee38a8b2&lang=scss"
import "./OfferTooltipInfo.vue?vue&type=style&index=1&id=ee38a8b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee38a8b2"],['__file',"webpack-assets/vue/templates/product/catalog/parts/OfferTooltipInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee38a8b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee38a8b2', __exports__)) {
    api.reload('ee38a8b2', __exports__)
  }
  
  module.hot.accept("./OfferTooltipInfo.vue?vue&type=template&id=ee38a8b2&scoped=true", () => {
    api.rerender('ee38a8b2', render)
  })

}


export default __exports__